// Copyright Epic Games, Inc. All Rights Reserved.

import { ESystemID, makeErrorCode } from "./index";

enum ESelfUpdateErrors {
  UnexpectedError = "UE",
  BadConfiguration = "BC",
  FailedFetch = "FF",
}

/**
 * @ErrorCode EOS-IN-UE
 * @Description Unexpected error was caught during installation flow.
 */
export const InstallationUnexpectedErrorErrorCode = makeErrorCode(
  ESystemID.IN,
  ESelfUpdateErrors.UnexpectedError
);

/**
 * @ErrorCode EOS-IN-BC
 * @Description Provided URL does not contains the mainServiceAccessToken query param
 * so the UI SPA has bad configuration and can not perform a task.
 */
export const InstallationBadConfigurationErrorCode = makeErrorCode(
  ESystemID.IN,
  ESelfUpdateErrors.BadConfiguration
);

/**
 * @ErrorCode EOS-IN-FF
 * @Description UI SPA failed to fetch data from the the EOSH. This error means
 * that we do not received an HTTP response from the fetch call. It can be due to
 * any errors that happened during of request e.g. net::ERR_CONNECTION_REFUSED.
 * We have only one error code for all cases, because browser do not expose this
 * error codes to us.
 */
export const InstallationFailedFetchErrorCode = makeErrorCode(
  ESystemID.IN,
  ESelfUpdateErrors.FailedFetch
);
